import React from "react";
import PropTypes from "prop-types";

export default class DataDefinitionModule extends React.Component {
    render() {
        const { open, onToggleOpen, name, error, keyboardShortcuts, options, sequenceNumber, codingInstructions, targetValue,
            definitions, notes, shortName, relatedLinks } = this.props;

        const shortcuts = keyboardShortcuts && keyboardShortcuts
            .slice(0,10)
            .map(option => <li key={option.key}><kbd>{option.key}</kbd>= {option.name}</li>);
        const optionItemsDetailed = options.map((option) => <li key={option.label}>{option.label}{option.description ? `: ${option.description}` : ""}</li>);
        const codingInstructionsItems = codingInstructions.map((inst) => <p key={inst.body}>{inst.body.trim()}</p>);
        const targetValueItems = targetValue.map((tv) => <p key={tv.body}>{tv.body.trim()}</p>);
        const definitonItems = definitions.map((d, i) => (<div key={d.term}>
            <strong>{d.term}</strong>
            <p>
                {d.definition.trim()}
                <br />
                <cite>{d.source}</cite>
            </p>
        </div>));
        const noteItems = notes.map(note => <p key={note.body}>{note.body.trim()}</p>);
        const relatedLinksItems = relatedLinks.map(note => {
            let body = note.body;
            // find and replace all the MD links in body and convert them to html links that open in a new tab.
            const regexMdLinks = /\[([^[]+)](\([^)]*\))/gm;
            const mdLinkMatches = body.match(regexMdLinks);
            const singleMatch = /\[([^[]+)]\((.*)\)/;
            for (let i = 0; i < mdLinkMatches.length; i++) {
              const linkInfo = singleMatch.exec(mdLinkMatches[i]);
              const [ , title, url] = linkInfo;
              body = body.replace(mdLinkMatches[i], `<a href="${url}" target="_blank">${title}</a>`);
            }
            return (
                <li key={note.body} dangerouslySetInnerHTML={{__html: body}}/>
            );
        });
        const headingTitle = name ? `${name} - Definition` : "";
        return (
            <div className={`data-definitions ${open === null ? "neutral" : open ? "expanded" : "collapsed"}`}>
                <div className="panel-heading" onClick={onToggleOpen}>
                    {headingTitle}&#8203;
                </div>
                <div className="panel-body">
                    {error ?
                    <h2>Unable to load definitions from server due to network error.</h2>
                    :
                    <React.Fragment>
                        {shortcuts &&
                        <React.Fragment>
                            <div className="section-title">Keyboard Shortcuts</div>
                            <ul className="keyboard-shortcuts">
                                {shortcuts}
                            </ul>
                        </React.Fragment>
                        }
                        <div className="section-title">Field Definitions</div>
                        <dl className="field-definitions">
                            {sequenceNumber &&
                            <React.Fragment>
                                <dt className="pull-left">Seq. #:</dt>
                                <dd className="text-right">{sequenceNumber}</dd>
                            </React.Fragment>
                            }
                            {shortName &&
                            <React.Fragment>
                                <dt className="pull-left">Short Name:</dt>
                                <dd className="text-right">{shortName}</dd>
                            </React.Fragment>
                            }
                            {codingInstructions.length > 0 &&
                            <React.Fragment>
                                <dt>Coding Instruction</dt>
                                <dd>{codingInstructionsItems}</dd>
                            </React.Fragment>
                            }
                            {targetValue.length > 0 &&
                            <React.Fragment>
                                <dt>Target Value</dt>
                                <dd>{targetValueItems}</dd>
                            </React.Fragment>
                            }
                            {options.length > 0 &&
                            <React.Fragment>
                                <dt>Selections</dt>
                                <dd>
                                    <ul className="selection-definitions">
                                        {optionItemsDetailed}
                                    </ul>
                                </dd>
                            </React.Fragment>
                            }
                            {definitions.length > 0 &&
                            <React.Fragment>
                                <dt>Supporting Definitions</dt>
                                <dd>{definitonItems}</dd>
                            </React.Fragment>
                            }
                            {notes.length > 0 &&
                            <React.Fragment>
                                <dt>Additional Notes</dt>
                                <dd>{noteItems}</dd>
                            </React.Fragment>
                            }
                            {relatedLinks.length > 0 &&
                            <React.Fragment>
                                <dt>Related Links</dt>
                                <dd>
                                    <ul className="links-definitions">
                                        {relatedLinksItems}
                                    </ul>
                                </dd>
                            </React.Fragment>
                            }
                        </dl>
                    </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

DataDefinitionModule.propTypes = {
    name: PropTypes.string,
    error: PropTypes.any,
    open: PropTypes.any,
    onToggleOpen: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            description: PropTypes.string,
        })
    ).isRequired,
    keyboardShortcuts: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ),
    sequenceNumber: PropTypes.string,
    shortName: PropTypes.string,
    codingInstructions: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string.isRequired,
        })
    ).isRequired,
    targetValue: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string.isRequired,
        })
    ).isRequired,
    definitions: PropTypes.arrayOf(
        PropTypes.shape({
            term: PropTypes.string.isRequired,
            definition: PropTypes.string.isRequired,
            source: PropTypes.string,
        })
    ).isRequired,
    notes: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string.isRequired,
        })
    ).isRequired,
    relatedLinks: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string.isRequired,
        })
    ).isRequired
};

DataDefinitionModule.defaultProps = {
    options: [],
    codingInstructions: [],
    targetValue: [],
    definitions: [],
    notes: [],
    relatedLinks: [],
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/datadefinition/DataDefinitionModule.js